// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RegisterForm-displayGridDate-fbBKy {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px 8px;
}


.RegisterForm-checkBoxGrid-LgYGG {
    display: grid;
    grid-template-columns: 24px auto;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}


.RegisterForm-checkBoxText-FtxP7 {
    padding-left: 7px;
}


@media screen and (max-width: 767px) {
    .RegisterForm-displayGridDate-fbBKy {
        grid-template-columns: 100%;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/RegisterForm/RegisterForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,gCAAgC;IAChC,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;;AAEA;IACI,iBAAiB;AACrB;;;AAEA;IACI;QACI,2BAA2B;IAC/B;;AAEJ","sourcesContent":[".displayGridDate {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 18px 8px;\n}\n\n\n.checkBoxGrid {\n    display: grid;\n    grid-template-columns: 24px auto;\n    align-items: flex-start;\n}\n\n.checkBoxText {\n    padding-left: 7px;\n}\n\n@media screen and (max-width: 767px) {\n    .displayGridDate {\n        grid-template-columns: 100%;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayGridDate": `RegisterForm-displayGridDate-fbBKy`,
	"checkBoxGrid": `RegisterForm-checkBoxGrid-LgYGG`,
	"checkBoxText": `RegisterForm-checkBoxText-FtxP7`
};
module.exports = ___CSS_LOADER_EXPORT___;
